import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./styles.css";
import Header from "../../components/Header";

const About = ({ isConnected, isConnectedToASession, onStartConnecting }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isConnected) {
      onStartConnecting();
    }
  }, [isConnected]);

  useEffect(() => {
    if (isConnectedToASession) {
      navigate("/app");
    }
  }, [isConnectedToASession]);

  return (
    <div className="container column">
      <div>
        <Header />

        <h2 className="create-title">About MolecularWebXR</h2>

        <div className="column about-container">
          <div className="about-section">
            <h3 className="create-subtitle">What is MolecularWebXR?</h3>
            <p className="create-menu-text">
              MolecularWebXR is the Metaverse’s ultimate immersive tool for education and discussion in chemistry and
              structural biology. Use alone or meeting with other people in virtual rooms where you can
              discuss and manipulate objects relevant to chemistry, materials science and structural biology in real time
              using augmented reality (AR) or virtual reality (VR).
            </p>
            <p className="create-menu-text">
              You just came back and found this website all new? Perhaps you're looking what we now call Science XR, which corresponds to the previous MolecularWebXR version!
            </p>
          </div>
          <div className="about-section">
            <h3 className="create-subtitle">Two types of sessions available:</h3>
            <p className="create-menu-text">
              <b>Science XR:</b> static content for education, outreach and discussions in science, pre-made in the educational/outreach rooms or custom-built with our 
              {" "}
              <a
                href="https://molecularweb.epfl.ch/pages/pdb2ar.html"
                target="_blank"
                rel="noopener noreferrer"
                className="create-menu-text link"
              >
                PDB2AR
              </a>{" "}
              tool. This corresponds to the "old" MolecularWebXR as described in
              {" "}
              <a
                href="https://www.sciencedirect.com/science/article/pii/S1093326324002328"
                target="_blank"
                rel="noopener noreferrer"
                className="create-menu-text link"
              >
                this paper
              </a>{" "}.
            </p>
            <p className="create-menu-text">
              <b>HandMol:</b> Immersive, multiuser molecular graphics with interactive simulations, starting from atomic coordinates in PDB format.
            </p>
          </div>
          <div className="about-section">
            <h3 className="create-subtitle">Authors</h3>
            <p className="create-menu-text">
              Developed by{" "}
              <a
                href="https://www.fjcr.pro/"
                target="_blank"
                rel="noopener noreferrer"
                className="create-menu-text link"
              >
                Fabio Cortes Rodriguez
              </a>{" "}
              and{" "}
              <a
                href="https://www.lucianoabriata.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="create-menu-text link"
              >
                Luciano Abriata
              </a>{" "}
              with contributions from Lucien Krapp, Fernando Teixeira Pinto Meireles and other members of{" "}
              <a
                href="https://www.epfl.ch/labs/lbm/"
                target="_blank"
                rel="noopener noreferrer"
                className="create-menu-text link"
              >
                EPFL's Laboratory for Biomolecular Modeling
              </a> (Dal Peraro lab).
            </p>
          </div>
          <div className="about-section">
            <p className="create-menu-text">
              <h3 className="create-subtitle">Usage statistics</h3>
              <span>
                For this new MolecularWebXR version:
                {" "}
                <a
                  href="https://clustrmaps.com/site/1c5k3"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="create-menu-text link"
                >
                  Check here
                </a>.
              </span>
            </p>
            <p className="create-menu-text">
                For  the original MolecularWebXR (current Science XR branch)
                {" "}
                <a
                  href="https://clustrmaps.com/site/1bwmt"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="create-menu-text link"
                >
                  check here
                </a>.
            </p>
          </div>
          <p className="create-menu-text">
            While we prepare a paper, find out more about MolecularWebXR by reading the{" "}
              <a
                href="https://killcloud.nyc3.cdn.digitaloceanspaces.com/scenes/mwxr_manual.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="create-menu-text link"
              >
                user's manual.
              </a>
          </p>
        </div>
      </div>
      <p className="footer">© 2025 MolecularWebXR. All rights reserved. Part of the
        {" "}
        <a
          href="https://molecularweb.org"
          target="_blank"
          rel="noopener noreferrer"
          className="create-menu-text link"
        >Molecularweb.org</a>
        {" "}
        universe</p>
    </div>
  );
};

export default About;
